import {
  PRODUCT_SEARCH_FACETS_CSV,
  TYPESENSE_COLLECTION,
} from './typesense-search-config';

export { TYPESENSE_PUBLISHED_PRODUCTS_FILTER } from './typesense-search-config';

export const PRODUCT_SEARCH_FACETS_STRING = PRODUCT_SEARCH_FACETS_CSV;

export const PRODUCT_SEARCH_FACETS_ARRAY = PRODUCT_SEARCH_FACETS_CSV.split(',');

export const DEFAULT_TYPESENSE_COLLECTION = TYPESENSE_COLLECTION;

export const DEFAULT_SEARCH_ITEMS_PER_PAGE =
  Number(process.env.NEXT_PUBLIC_SEARCH_ITEMS_PER_PAGE ?? null) || 20;

export const HOME_SEARCH_INDEX_ID = 'products_home';

export const MAIN_SEARCH_INDEX_ID = 'products';

export const SEARCH_PAGE_CATEGORY_KEY = `products[refinementList][categories.name][0]`;

export const SEARCH_PAGE_BRAND_KEY = `products[refinementList][brand][0]`;

export const SEARCH_PAGE_MANUFACTURER_KEY = `products[refinementList][manufacturer][0]`;

export const TYPESENSE_SEARCH_STATUS_PUBLISH = 'status_id:=2';
